import React from "react";
import { Query } from "react-apollo";
import { Button, Row, Col } from "antd";
import { Link } from "react-router-dom";

import { RESEARCH_REQUEST } from "../queries";
import WithAuth from "../../../container/WithAuth";
import { withApolloState } from "../../../util";

import CommentForm from "../CommentForm";

import ContinuousMonitoringTitle from "./ContinuousMonitoringTitle";
import Results from "./ContinuousMonitoringTable";

const ContinuousMonitoring = props => {
    const {
        researchRequest: { entity },
        entitySchema,
    } = props.apolloProps.data;
    const { ulid: researchRequestUlid } = props.match.params;
    return (
        <>
            <ContinuousMonitoringTitle
                entitySchema={entitySchema}
                entity={entity}
            />
            <Row type="flex" justify="center">
                <Col span={24} xxl={18}>
                    <Row>
                        <Results
                            researchRequestUlid={researchRequestUlid}
                            auth={props.auth}
                        />
                    </Row>
                    <Row>
                        <CommentForm
                            ulid={researchRequestUlid}
                            tags={{ page: "continuous_monitoring" }}
                        />
                    </Row>
                    <Row
                        type="flex"
                        justify="end"
                        style={{ paddingTop: "1em" }}
                    >
                        <Link to="/tickets">
                            <Button size="large" type="primary">
                                Close
                            </Button>
                        </Link>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

const ContinuousMonitoringPageQuery = props => (
    <Query
        query={RESEARCH_REQUEST}
        fetchPolicy="cache-and-network"
        variables={{
            id: btoa("ResearchRequest:" + props.match.params.ulid),
        }}
    >
        {withApolloState(apolloProps => (
            <ContinuousMonitoring {...props} apolloProps={apolloProps} />
        ))}
    </Query>
);

export default WithAuth(ContinuousMonitoringPageQuery);
